import type { Tier } from '@utils/tiers';
import { useProductEntry } from '@features/products/useProductEntry';

/**
 * The working customer's tier, the Learning Center's two-valued view of the Valet operational
 * model: self-managed (and mixed) reads as `lite`, hopdrive-managed as `standard`, and an
 * unresolved model (products not loaded) as null.
 */
export function useCurrentTier(): Tier | null {
  const model = useProductEntry('moves')?.operationalModel?.default;
  if (!model) return null;
  return model === 'hopdrive-managed' ? 'standard' : 'lite';
}
